import { placeholderImage, createImageUrl, isString } from "@grandvisionhq/utils";
import { customTransitionLensConfig, defaultTransitionLensConfig } from "../../../../../config/modules/VTO/VirtualMirror/config/transition-lens-config.js";
import { SINGLE_PURCHASE } from "../../../../../../../../types/types/purchase-types.js";
const defaultImageParams = { fit: "fill", format: "png" };
const mapGraphVariantsToVirtualMirror = (product, variants, activeSku, brandLogo, isVtoTransitionsEnabled = false) => {
  const prices = variants.filter((variant) => variant.isVtoEnabled).map((variant) => {
    const { purchaseTypePrices, sku } = variant;
    const { originalPrice, discountedPrice, currency } = purchaseTypePrices[SINGLE_PURCHASE];
    return {
      upc: sku,
      current: {
        text: `${originalPrice}`,
        value: originalPrice
      },
      ...discountedPrice && discountedPrice !== originalPrice && {
        previous: {
          text: `${originalPrice}`,
          value: originalPrice
        },
        current: {
          text: discountedPrice && `${discountedPrice}`,
          value: discountedPrice && discountedPrice
        }
      },
      currency
    };
  }).reduce(
    (acc, curr) => curr?.upc === activeSku ? [curr, ...acc] : [...acc, curr],
    []
  );
  const isTransitionEnabled = isVtoTransitionsEnabled && product.isOfferedWithPrescriptions;
  const products = variants.filter((variant) => variant.isVtoEnabled).map((variant) => {
    const { brandModelCode, brandModelColorCode, sku, displayName, media, specifications } = variant;
    const variantImages = media.images?.length > 0 ? media.images : [placeholderImage];
    const frameColors = specifications.find(
      (spec) => spec.specificationAttribute === "frameColor"
    )?.value;
    const frameColor = Array.isArray(frameColors) ? frameColors.join(" / ") : frameColors;
    const lensColor = specifications.find(
      (spec) => spec.specificationAttribute === "lensColor"
    )?.value;
    const transitionLens = isTransitionEnabled ? customTransitionLensConfig : defaultTransitionLensConfig;
    return {
      upc: sku,
      code: brandModelCode ?? "",
      name: displayName,
      colorCode: brandModelColorCode ?? "",
      thumbnailUrl: createImageUrl(variantImages[0].url, {
        ...defaultImageParams,
        width: 224
      }),
      brand: {
        name: product.brandName,
        logoUrl: brandLogo ?? ""
      },
      lensColorLabel: isString(lensColor) ? lensColor : "",
      frameColorLabel: isString(frameColor) ? frameColor : "",
      styleName: "",
      isCustom: false,
      size: "58 14",
      isTransition: isTransitionEnabled,
      transitionLens
    };
  }).reduce(
    (acc, curr) => curr.upc === activeSku ? [curr, ...acc] : [...acc, curr],
    []
  );
  return {
    prices,
    products
  };
};
export {
  mapGraphVariantsToVirtualMirror
};
//# sourceMappingURL=mapGraphVariantsToVirtualMirror.js.map
